import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import pdfIcon from './pdf.svg';
import zipIcon from './zip.svg';
import fileIcon from './file.svg';

import styles from './FilenameWithIcon.css';

export default function FilenameWithIcon({ filename, text, iconClassName, ...props }) {
    let type = (filename.split('.').pop() || '').toLowerCase();
    let icon;

    switch (type) {
        case 'pdf':
            icon = pdfIcon;
            break;
        case 'zip':
            icon = zipIcon;
            break;
        default:
            icon = fileIcon;
            break;
    }

    return (
        <span {...props}>
            <img src={icon} className={classnames(styles.fileIcon, iconClassName)} alt="" /> {text || filename}
        </span>
    );
}

FilenameWithIcon.propTypes = {
    filename: PropTypes.string,
    text: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/UI/FilenameWithIcon/FilenameWithIcon.js